// Owner/admin account for gated test-only features (e.g. Clover checkout).
// The backend independently enforces this; the frontend uses it only for UI visibility.
export const ADMIN_EMAIL = "mealsbywaj@gmail.com";

export const isAdmin = (user) =>
  !!user && (user.email || "").toLowerCase() === ADMIN_EMAIL;
